
import XHeader from 'vux/src/components/x-header/index.vue'

import Group from 'vux/src/components/group/index.vue'

import Cell from 'vux/src/components/cell/index.vue'

import XButton from 'vux/src/components/x-button/index.vue'

import Divider from 'vux/src/components/divider/index.vue'

import InfiniteLoading from 'vue-infinite-loading';

export default {
components: {
XHeader,
Group,
Cell,
XButton,
Divider,
InfiniteLoading
},
data() {
return {

balanceList: [],

currentPage: 1,
}
},
methods: {
infiniteHandler($state) {
const cateID = this.$route.params.cateId;
const url = `${this.tianYiWebUrl}/wechat/uc/logPromiseBalance`;
this.$http.get(url, {params: {page: this.currentPage, cateId: cateID}}).then(r => {
const res = r.data;
if (res.code === 200) {
this.balanceList = [...this.balanceList, ...res.data.data];
if (res.data.total > res.data.per_page * res.data.current_page) {
this.currentPage++;
$state.loaded()
} else {
$state.complete();
}

this.btnShowLoading = false
}
})
}
},
created:function(){
document.title='库存列表'
},
}



// WEBPACK FOOTER //
// ./src/components/uc/PromiseBalance.vue